import { Card } from '@gurupay/gp-ui-library';
import { useCompanyDetails } from '@hooks/useCompanyDetails';
import { useTranslation } from 'react-i18next';

import { EMPTY_VALUE } from '../utils';
import { InfoRow } from './InfoRow';

export const CompanyDetails = () => {
	const { data: company, isLoading } = useCompanyDetails();
	const { t } = useTranslation('', { keyPrefix: 'profile' });
	const address =
		[
			company?.address?.line,
			company?.address?.building_number,
			company?.address?.postal_code,
			company?.address?.town,
			company?.address?.country,
		]
			.filter(Boolean)
			.join(' ') || EMPTY_VALUE;

	return (
		<Card className="max-w-[512px] mb-space-40" title={t('companyTitle')}>
			<InfoRow
				isLoading={isLoading}
				label={t('companyName')}
				value={company?.company_name || EMPTY_VALUE}
			/>
			<InfoRow
				isLoading={isLoading}
				label={t('companyCode')}
				value={company?.registration_number || EMPTY_VALUE}
			/>
			<InfoRow isLoading={isLoading} label={t('address')} value={address} />
		</Card>
	);
};
